<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [data]="patients"
  [totalCount]="totalPatient"
  [columns]="columns"
  [filters]="filters"
  (filtersChange)="filterPatientList($event.filters, $event.sort)"
  (onPageChange)="onPageChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
  [tableLoading]="patientListLoading"
  [totalPage]="totalPage"
  [pageSize]="pageSize"
  [columnWidths]="columnWidths"
  (handleGetPatientList)="getPatientList(1, pageSize, filters)"
></app-tables>
